import React from 'react';
import { useFormikContext } from 'formik';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import { FaSpinner } from 'react-icons/fa';
import classnames from 'classnames';
import Input from '../Input';
import CustomHeader from '../CustomHeader';
import { zipcodeMask, phoneMask } from '../../utils/masks';
import useMe from '../../hooks/useMe';

const zipcodeGql = gql`
  query zipcodeInfos($zipcode: String!) {
    zipcodeInfos(zipcode: $zipcode) {
      city
      street
      neighbourhood
      state
    }
  }
`;

export default function CondominiumRegister({ header }) {
  const [me] = useMe();

  const {
    values: { condominium },
    errors,
    isSubmitting,
    handleChange,
    isValid,
    handleSubmit,
  } = useFormikContext();

  // TODO: criar um componentezinho pro input de cep com a info de endereço -> pra tirar essa lógica daqui do condominio
  const { data: zipCodeResult, loading: loadingZipcode } = useQuery(
    zipcodeGql,
    {
      skip:
        !me &&
        errors.condominium &&
        errors.condominium.address &&
        errors.condominium.address.zipcode,
      fetchPolicy: 'no-cache',
      variables: {
        zipcode: condominium.address.zipcode,
      },
    },
  );

  return (
    <div className="condominium-register">
      {header && (
        <CustomHeader title="Cadastre o novo condomínio" to="/dashboard" />
      )}
      {!header && (
        <div className="justify-content-center d-flex p-3">
          <h4>Cadastre o condomínio</h4>
        </div>
      )}
      <form className="form" noValidate onSubmit={handleSubmit}>
        <div className="form-group text-left">
          <label>Nome do condominio</label>
          <Input
            focus
            className={classnames('form-control', {
              'is-invalid': errors.condominium && errors.condominium.name,
            })}
            value={condominium.name}
            onChange={handleChange}
            name="condominium.name"
          />
        </div>
        <div className="form-group text-left">
          <label>CNPJ</label>
          <Input
            className={classnames('form-control', {
              'is-invalid': errors.condominium && errors.condominium.doc,
            })}
            type="tel"
            value={condominium.doc}
            onChange={handleChange}
            name="condominium.doc"
          />
        </div>
        <div className="form-group text-left">
          <label>Total de Unidades</label>
          <Input
            className={classnames('form-control', {
              'is-invalid': errors.condominium && errors.condominium.totalUnits,
            })}
            type="number"
            value={condominium.totalUnits}
            onChange={handleChange}
            name="condominium.totalUnits"
          />
        </div>
        <div className="form-group text-left">
          <label>CEP</label>
          <Input
            mask={zipcodeMask}
            className={classnames('form-control', {
              'is-invalid':
                errors.condominium &&
                errors.condominium.address &&
                errors.condominium.address.zipcode,
            })}
            type="tel"
            onChange={handleChange}
            value={condominium.address.zipcode}
            name="condominium.address.zipcode"
          />

          {loadingZipcode && <FaSpinner />}
          {zipCodeResult &&
            zipCodeResult.zipcodeInfos &&
            zipCodeResult.zipcodeInfos.city && (
              <p>
                <br />
                {`${zipCodeResult.zipcodeInfos.street} - ${zipCodeResult.zipcodeInfos.neighbourhood}`}
                <br />
                {`${zipCodeResult.zipcodeInfos.city} / ${zipCodeResult.zipcodeInfos.state}`}
              </p>
            )}
        </div>
        <div className="form-group text-left">
          <label>Número</label>
          <Input
            className={classnames('form-control', {
              'is-invalid':
                errors.condominium &&
                errors.condominium.address &&
                errors.condominium.address.number,
            })}
            type="number"
            onChange={handleChange}
            value={condominium.address.number}
            name="condominium.address.number"
          />
        </div>
        <div className="form-group text-left">
          <label>Telefone (com DDD)</label>
          <div className="input-group mb-3 row">
            <div className="col-4">
              <Input
                disabled
                value={condominium.country}
                name="condominium.country"
                onChange={handleChange}
              />
            </div>
            <Input
              mask={phoneMask}
              className={classnames('form-control', {
                'is-invalid':
                  errors.condominium && errors.condominium.phoneNumber,
              })}
              value={condominium.phoneNumber}
              name="condominium.phoneNumber"
              onChange={handleChange}
            />
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-block btn-primary"
          disabled={!isValid}
        >
          {isSubmitting ? (
            <>
              <FaSpinner />
              &nbsp;&nbsp;Criando seu condomínio
            </>
          ) : (
            'Registrar'
          )}
        </button>
      </form>
    </div>
  );
}
